/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { Fragment } from "react";

import type { ChosenDigitalAssets } from "@spwn/types/firebase/firestore";

type Props = {
  chosenDigitalAssets?: ChosenDigitalAssets;
  bonusMedias?: {
    bonusName: string;
  }[];
};

/**
 * チケットに紐づく特典情報を表示するコンポーネント
 * - 選択デジタル特典
 * - 付与特典
 * TODO: 文言デザインこれでいいか確認した後文言など修正
 */
export const TicketBonusMediaDisplay: React.FC<Props> = ({
  chosenDigitalAssets,
  bonusMedias,
}) => {
  const { t } = useI18n();
  const hasDigitalAssets =
    chosenDigitalAssets && Object.keys(chosenDigitalAssets).length > 0;
  const hasBonusMedias = bonusMedias && bonusMedias.length > 0;

  if (!hasDigitalAssets && !hasBonusMedias) {
    return null;
  }

  return (
    <Fragment>
      {hasDigitalAssets && (
        <Fragment>
          <p>{t("event.ticket.headline.grantedBenefits")}</p>
          <p css={styles.benefitText}>
            {Object.entries(chosenDigitalAssets)
              .flatMap(([_, assetData]) => {
                return Object.entries(assetData).map(([_, assetData]) => {
                  return assetData;
                });
              })
              .map((assetData) => {
                const assetName = assetData.digitalAssetName;
                const { groupName } = assetData;
                return groupName ? `【${groupName}】${assetName}` : assetName;
              })
              .join(", ")}
          </p>
        </Fragment>
      )}
      {hasBonusMedias && (
        <Fragment>
          <p>{t("event.ticket.headline.grantedBenefits")}</p>
          <p css={styles.benefitText}>
            {bonusMedias.map((media) => media.bonusName).join(", ")}
          </p>
        </Fragment>
      )}
    </Fragment>
  );
};

const styles = {
  benefitText: {
    fontSize: "12px",
    color: "black",
    marginTop: "4px",
    marginBottom: "20px",
  },
} as const;
